<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="order_detailLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="order_detailError" class="mc-error">{{ order_detailError }}</div>
      <div v-if="order_detailLoaded" class="mc-order">
        <div class="mc-order__card mc-order-card">
          <div class="mc-order-card__top">
                            <span class="mc-order-card__status">
                                {{ order_detail.status }}
                            </span>
            <div class="mc-order-card__title">
              Заказ #{{ order_detail.number }} от {{ order_detail.date_create }}
            </div>
          </div>
          <dl class="mc-order-card__list">
            <div v-for="payment in order_detail.payments" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Способ оплаты:
              </dt>
              <dd class="mc-order-card__description">
                {{ payment.NAME }}
              </dd>
            </div>
            <div class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Стоимость товара:
              </dt>
              <dd class="mc-order-card__description">
                {{ order_detail.items_price }} ₽
              </dd>
            </div>
            <div class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Стоимость доставки:
              </dt>
              <dd class="mc-order-card__description">
                {{ order_detail.delivery_price }} ₽
              </dd>
            </div>
            <div class="mc-order-card__item mc-order-card__item--total">
              <dt class="mc-order-card__term">
                Всего к оплате:
              </dt>
              <dd class="mc-order-card__description">
                {{ order_detail.sum }} ₽
              </dd>
            </div>
          </dl>
          <template v-for="payment in order_detail.payments">
          <div v-if="payment.url" class="mc-order-card__bottom">
            <a class="mc-button mc-button--color" :href="payment.url" target="_blank">
                                <span class="mc-button__text">
                                    Оплатить
                                </span>
            </a>
          </div>
          </template>
        </div>
        <ul class="mc-order__list">
          <li v-for="product in order_detail.items" class="mc-order__item">
            <router-link :to="product.url" class="mc-product-item">
              <div class="mc-product-item__image-wrapper">
                <picture class="mc-product-item__picture">
                  <img class="mc-product-item__image" :src="product.picture" width="94" height="157" alt="">
                </picture>
              </div>
              <div class="mc-product-item__body">
                                    <span class="mc-product-item__title">
                                        {{ product.name }}
                                    </span>
                <span class="mc-product-item__code">
                                        {{ product.artnumber }}
                                    </span>
                <div class="mc-product-item__price mc-price">
                                        <span v-if="product.final > product.final_price" class="mc-price__old">
                                            {{ product.price }} ₽
                                        </span>
                  <span class="mc-price__current">
                                            {{ product.final_price }} ₽
                                        </span>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
        <div class="mc-order__card mc-order-card">
          <dl class="mc-order-card__list mc-order-card__list--grid">
            <div v-for="delivery in order_detail.shipments" class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Доставка
              </dt>
              <dd class="mc-order-card__description">
                {{ delivery.NAME }}
              </dd>
            </div>
            <div class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Адрес
              </dt>
              <dd class="mc-order-card__description">
                {{ order_detail.props.ADDRESS }}
              </dd>
            </div>
            <div class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Телефон
              </dt>
              <dd class="mc-order-card__description">
                {{ order_detail.props.PHONE }}
              </dd>
            </div>
            <div class="mc-order-card__item">
              <dt class="mc-order-card__term">
                Получатель
              </dt>
              <dd class="mc-order-card__description">
                {{ order_detail.props.FIO }}
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import order_detail from "@/store/order_detail";

export default {
  computed: {
    ...mapGetters([
      'order_detail',
      'order_detailLoading',
      'order_detailError',
      'order_detailLoaded'
    ])
  },
  mounted() {

  },
  created() {
    this.fetchOrder_detail(this.$route.params.id);
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchOrder_detail',
    ]),
  },
}
</script>


